import React, { createContext, useContext } from 'react';

const ENV_EMPRESA_ID = Number(process.env.REACT_APP_EMPRESA_ID || 1);
const EmpresaContext = createContext<number>(ENV_EMPRESA_ID);

export function EmpresaProvider({
  empresaId,
  children,
}: {
  empresaId: number;
  children: React.ReactNode;
}) {
  return (
    <EmpresaContext.Provider value={empresaId}>
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresaId(): number {
  return useContext(EmpresaContext);
}
